import { useEffect, useState } from "react";
import { decodeJwt } from "jose";
import { useAuth0 } from "@auth0/auth0-react";

/**
 * Récupère le JWT Auth0 et le tenant_id associé.
 */
export function useAuthToken() {
  const { getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState("");
  const [tenant, setTenant] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function loadAccessToken() {
      setLoading(true);
      try {
        const accessToken = await getAccessTokenSilently();
        const claims = decodeJwt(accessToken);
        if (cancelled) return;
        setToken(accessToken);
        setTenant(claims.tenant_id || "");
        setError("");
      } catch (err) {
        if (!cancelled) {
          console.error(err);
          setToken("");
          setTenant("");
          setError("Impossible de récupérer le jeton d'accès.");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    loadAccessToken();
    return () => {
      cancelled = true;
    };
  }, [getAccessTokenSilently]);

  return { token, tenant, error, loading };
}
